import React, {useContext} from 'react';
import EnableFileFormatTabs from './Tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';

function EnableFileFormat() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <div className={` ${classes.cardBordernoneStyles} mb-0`}>
      <EnableFileFormatTabs />
    </div>
  );
}

export default EnableFileFormat;
